<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12 md8 offset-md2>
                <h1 class="font-weight-light display-1 text-center px-3 my-3 titolo-pagamento"
                    :class="{'title': $vuetify.breakpoint.mdAndDown}"> 
                    Riepilogo appuntamento e pagamento acconto 
                </h1>
            </v-flex>
            <v-flex class="my-4" xs12 md4 offset-md4>
                <v-card class="pa-3">
                    <div> <b>Cliente: </b> {{ appuntamento.nomeCliente }} {{ appuntamento.cognomeCliente }} </div>
                    <div> <b>Data: </b> {{ appuntamento.data }} </div>
                    <div> <b>Ora: </b> {{ appuntamento.ora }} </div>
                    <div> <b>Servizio: </b> {{ appuntamento.nomeServizio }} {{ effetto }} {{ appuntamento.effetto }} {{ luxury }}</div>
                    <div> <b>Lashmaker: </b> {{ appuntamento.nomeLashmaker }} {{ appuntamento.cognomeLashmaker }} </div>
                    <div> <b>Durata: </b> {{ appuntamento.durataServizio }} </div>
                    <div> <b>Acconto del 30%: </b> {{ acconto }} €</div>
                </v-card>
                <!-- <h1> {{appuntamento}} </h1> -->
            </v-flex>

            <v-flex class="my-4" xs12 md4 offset-md4>
                <div ref="paypal"></div>
            </v-flex>
            <v-flex class="my-4 pl-5" xs12 md4>
                <v-btn @click="tornaIndietro()">
                    <v-icon large>arrow_back</v-icon>
                    Indietro
                </v-btn>
            </v-flex> 
            
        </v-layout>
        <v-snackbar v-model="snackbar" :timeout="10000" color="success">
            <span>Prenotazione effettuata.</span>
            <v-btn flat color="white" @click="snackbar=false">Close</v-btn>
        </v-snackbar>        
    </v-container>
</template>

<script>
import fb from "@/fb"
//import PayPal from 'vue-paypal-checkout'

export default {
    name: "pagamento", 
    data() {
        return {
            appuntamento: this.$route.params.appuntamento,
            snackbar: false
        }
    },
    computed: {
        effetto() {
            if (this.appuntamento.effetto == "Laminazione") {
                return ""
            } else {
                return  "Effetto"
            }
        },
        luxury() {
            if (this.appuntamento.luxury) {
                return "LUXURY"
            } else {
                return  "BASE"
            }
        },
        acconto() {
            return Math.floor(this.appuntamento.prezzoServizio * 0.3)
        },
        descrizione() {
            return "Acconto " + this.appuntamento.nomeServizio + this.effetto + this.appuntamento.effetto + this.luxury
        }
    },
    mounted: function() {
        const script = document.createElement("script");
        //script.src =
        //"https://www.paypal.com/sdk/js?client-id=AbeyvUtQtNG92eTT_WlMGUY0zx1vF5ep1G4s669uV96n0mSliO19SxixaDNDgCgJqwr9MkYAvYXQJI6-&currency=EUR";
        script.src =
        "https://www.paypal.com/sdk/js?client-id=AbmRRzb4kKrJoVV6U66-63f3e0QKZjQJKY2uj8FOaYGdJI6sUS7rJ3kmbdpiGXvDcDXzZWUDIkAmenrD&currency=EUR";
        script.addEventListener("load", this.setLoaded);
        //this.$on('my-event', this.setLoaded)
        //EventBus.$on("paypal-script", this.setLoaded)
        document.body.appendChild(script);
    },
    methods: {
        tornaIndietro() {
            this.$router.back()
        },
        setLoaded: function() {
        this.loaded = true
        // CALCOLO IL 30% DEL PREZZO TOTALE DA FAR PAGARE IN ANTICIPO CON LA CARTA
        //  (ARROTONDAMENTO PER DIFETTO)      
        //var percentualePrezzo = Math.floor(this.prezzo * 0.3)
        //console.log(this.prezzo)
        window.paypal
            .Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                purchase_units: [
                    {
                    description: this.descrizione,
                    amount: {
                        currency_code: "EUR", 
                        value: this.acconto
                        //value: this.product.price
                    }
                    }
                ]
                });
            },         
            // eslint-disable-next-line  async
            onApprove: async (data, actions) => {
                const order = await actions.order.capture()
                //console.log(order)
                //RICREO L'OGGETTO APPUNTAMENTO SENZA IL CAMPO PREZZO X POTERLO SCRIVERE SU DB
                const appuntamentoDb = { 
                    data: this.appuntamento.data, 
                    ora: this.appuntamento.ora, 
                    nomeLashmaker: this.appuntamento.nomeLashmaker, 
                    cognomeLashmaker: this.appuntamento.cognomeLashmaker, 
                    nomeServizio: this.appuntamento.nomeServizio, 
                    effetto: this.appuntamento.effetto, 
                    durataServizio: this.appuntamento.durataServizio, 
                    luxury: this.appuntamento.luxury, 
                    email: this.appuntamento.email, 
                    nomeCliente: this.appuntamento.nomeCliente, 
                    cognomeCliente: this.appuntamento.cognomeCliente, 
                    telefono: this.appuntamento.telefono, 
                    stato: "da approvare", 
                    tipo: "appuntamento"
                }
                fb.db.collection('appuntamenti').add(appuntamentoDb).then(
                this.snackbar = true
                //this.panel = -1,
                //this.appuntamento = []
                ) //.catch( err => console.log(err.message))         
                //this.data;
                //this.paidFor = true
                //console.log(order);
            },
            onError: err => {
                // eslint-disable-next-line
                console.log(err.message)
            }
            })
            .render(this.$refs.paypal)
        }
    }    

    
}
</script>

<style scoped>
.titolo-pagamento{text-align: center!important;}

</style>